'use client'
import {
  AUCTION_LIST_QUERY
} from "./chunk-NPNDRLDV.mjs";
import {
  EVENT_LIST_QUERY
} from "./chunk-E577PGQH.mjs";
import {
  LINK_QUERY
} from "./chunk-Y5YNZ765.mjs";
import {
  IMAGE_QUERY
} from "./chunk-AFUSNP5S.mjs";

// src/api/queries/eventOtherOps.ts
var OTHER_BOOKING_OPTIONS_QUERY = `
id
title
subtitle
renderType
itemRenderType
sectionBackground {${IMAGE_QUERY}}
logo {${IMAGE_QUERY}}
webLinksCollection(limit: 2){items{${LINK_QUERY}}}
contentCollection(limit: 25) {
  items {
    __typename
      ... on Event {
      ${`${EVENT_LIST_QUERY}
      isStreamingEvent
      buyLiveStream{id}
      buttonIcon{${IMAGE_QUERY}}
      streamingMessage`}}
    ... on Experience {${EVENT_LIST_QUERY}}
    ... on Shows {${EVENT_LIST_QUERY}}
    ... on Restaurant {${EVENT_LIST_QUERY}}
    ... on Auction {${AUCTION_LIST_QUERY}}
  }
}
`;

export {
  OTHER_BOOKING_OPTIONS_QUERY
};
//# sourceMappingURL=chunk-6KZWPHJX.mjs.map